




























































































































































































































import { mapGetters, mapState } from 'vuex'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import {
  faEllipsisV,
  faReply,
  faThumbsDown,
  faThumbsUp
} from '@fortawesome/free-solid-svg-icons'
import { UserType } from '~/models/user/types'
import QnaAnswerForm from './QnaAnswerForm.vue'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import QnaActions from './QnaActions.vue'
import { QnaComment } from '~/models/qna/types'
import { USER_NS } from '~/store/modules/shared/user/state'
import { timeDistanceFromNow } from '~/utils/date'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { capitalizeSentences } from '~/utils/string'
import CContextMenu from '~/components/shared/configurable/CContextMenu.vue'
import { ReactionEnum } from '~/models/classified-list/types'
import { VipUsers } from '~/constants/vip-users'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import { defineComponent, PropType } from '~/utils/nuxt3-migration'
import CAnonGuardModal from '~/components/shared/configurable/user/CAnonGuardModal.vue'

export default defineComponent({
  name: 'QnaComment',
  components: {
    CAnonGuardModal,
    CAvatar,
    QnaAnswerForm,
    CConfirmationModal,
    QnaActions,
    CContextMenu,
    CBadge
  },
  props: {
    comment: { type: Object as PropType<QnaComment>, default: null },
    hasMoreVisible: { type: Boolean, default: false },
    seoUrl: { type: String, default: null }
  },
  data() {
    return {
      isCommentFormVisible: false,
      isDeleteAnswerModalVisible: false,
      editText: null,
      submitButtonTitle: null,
      isAnonGuardModalVisible: false
    }
  },
  computed: {
    UserType: () => UserType,
    ...mapGetters(USER_NS, {
      isAnon: 'isAnon',
      userIsAdmin: 'isAdmin',
      userId: 'userId'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile',
      isPc: 'isPc'
    }),
    ...mapState(USER_NS, {
      permissions: state => state.permissions
    }),

    reactionEnum() {
      return ReactionEnum
    },
    likes(): number {
      return this.comment.reactions.like || 0
    },
    numberOfRepliesText(): string {
      return capitalizeSentences(
        this.$i18n.tc(
          'view 1 reply | view {count} replies',
          this.comment.repliesCount
        )
      )
    },
    disLikes(): number {
      return this.comment.reactions.dislike || 0
    },
    nextUrl(): string {
      if (process.client) {
        return window.location.href
      }
      return ''
    },
    icons(): object {
      return {
        like: faThumbsUp,
        dLike: faThumbsDown,
        ellipsis: faEllipsisV,
        reply: faReply
      }
    },
    isCommentBelongsToUser(): boolean {
      return this.userId === this.comment.user.id
    },
    myReaction(): string {
      const { myReactions } = this.comment
      return myReactions.length ? myReactions[0] : null
    },
    isVip(): Boolean {
      return Object.values(VipUsers).includes(this.comment.user.id)
    },
    commentAdded() {
      return timeDistanceFromNow(this.comment.added)
    }
  },
  methods: {
    handleSubmit({
      comment,
      commentId
    }: {
      comment: QnaComment
      commentId: number
    }) {
      if (this.editText) {
        this.handleEditComment({ comment, commentId })
      } else {
        this.handleReplySubmit({ comment, commentId })
      }
    },
    handleReplySubmit({
      comment,
      commentId
    }: {
      comment: QnaComment
      commentId: number
    }) {
      this.$emit('submit', { comment, commentId })
      this.isCommentFormVisible = false
    },
    handleEditComment({
      comment,
      commentId
    }: {
      comment: string
      commentId: number
    }) {
      this.$emit('update-comment', { comment, commentId })
      this.isCommentFormVisible = false
    },
    handleEdit(comment: QnaComment) {
      if (!this.isCommentFormVisible) {
        this.submitButtonTitle = this.$i18n.t('update')
        this.editText = comment.comment
      } else {
        this.submitButtonTitle = null
        this.editText = null
      }
      this.isCommentFormVisible = !this.isCommentFormVisible
    },
    handleReply() {
      if (this.isAnon) {
        this.isAnonGuardModalVisible = true
      } else {
        this.isCommentFormVisible = !this.isCommentFormVisible
        this.submitButtonTitle = null
        this.editText = null
      }
    },
    handleDelete() {
      this.isDeleteAnswerModalVisible = true
    },
    handleConfirmationDeleteComment(comment: QnaComment) {
      this.$emit('delete-comment', comment)
    },
    handleReaction({
      commentId,
      reaction
    }: {
      commentId: number
      reaction: ReactionEnum
    }) {
      if (this.isAnon) {
        this.isAnonGuardModalVisible = true
      } else {
        this.$emit('reaction', { commentId, reaction })
      }
    },
    handleReport(commentId: number) {
      this.$emit('report', commentId)
    },
    handleChangeCommentVisibility({ commentId, isHidden }) {
      this.$emit('change-comment-visibility', {
        commentId,
        isHidden
      })
    },
    fetchMoreComments(commentId: number) {
      this.$emit('fetch-more-comments', commentId)
    }
  }
})
